import { isValidHttpsUrl } from './helpers'

class URLUtils {
  constructor(url) {
    this.href = url
    this.url = this._newUrl(url)
  }

  get host() {
    return this.url.host
  }

  get hostname() {
    return this.url.hostname
  }

  _newUrl(url) {
    try {
      if (isValidHttpsUrl(url)) {
        return new URL(url)
      }
      const [domain] = url.split('/')
      const rightUrl = `https://${domain}`

      if (!isValidHttpsUrl(rightUrl)) throw ('Invalid URL.')

      return new URL(rightUrl)
    } catch (error) {
      throw ({ message: 'Invalid URL', type: 'error_invalid_url' })
    }
  }
}

export default URLUtils
